import { Checkbox } from '@petsmart-ui/sparky';
import { useParams } from 'next/navigation';
import type { FormEvent } from 'react';

import type { FilterRefinementListItemProps } from '@/components/FilterRefinementList';
import { generateHref } from '@/utils/refinementsListUtils';

export default function CustomFilterRefinementListItem({
    attribute,
    item,
    refine,
    handlerAnalytics,
}: FilterRefinementListItemProps) {
    const handleChange = () => {
        refine(item.value);
        handlerAnalytics(item.value, !item.isRefined);
    };

    const handleLinkClick = (e: FormEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        handleChange();
    };

    const path = (useParams()?.slug as string[])?.join('/');
    const href = generateHref(path, attribute, item.value);

    return (
        <li className="custom-filter-refinement-list__container__li">
            <label className="custom-filter-refinement-list__item">
                <Checkbox
                    value={item.value}
                    checked={item.isRefined}
                    onChange={handleChange}
                    className="custom-filter-refinement-list__item--selected"
                />
                {href ? (
                    <a href={href} onClick={handleLinkClick} className="custom-filter-refinement-list__href">
                        <span>{item.label}</span>
                        <span className="custom-filter-refinement-list__item__count">{`(${item.count})`}</span>
                    </a>
                ) : (
                    <span className="custom-filter-refinement-list__href">
                        <span>{item.label}</span>
                        <span className="custom-filter-refinement-list__item__count">{`(${item.count})`}</span>
                    </span>
                )}
            </label>
        </li>
    );
}
